module.exports = __webpack_public_path__ + "static/img/住院预缴金@3x.2bf43b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/住院预缴金@3x.png
// module id = 307
// module chunks = 379 380